import React from "react";
import { Form, Input, Button, Row, Col } from 'antd';

export default function ChgGroup() {
    
    const onFinish = async (values) => {
        console.log('Success:', values);

        let resp = await fetch('/update/group', {
            method: 'PUT',
            body: JSON.stringify(values),
            headers: { 'Content-Type': 'application/json' },
        })
        let resp_data = await resp.json();
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    
    return (
        <div>
            <Row style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100vw',height:'100vh'}}>
                <Col span={24}>
                    <Form name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} style={{ maxWidth: 600 }} 
                        onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off"
                    >

                        <Form.Item wrapperCol={{ offset: 4, span: 20 }}>
                            <h3>Update Group</h3>
                        </Form.Item>

                        <Form.Item label="From" name="grpFrom" rules={[{ required: true, message: 'Please input your From Group!' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item label="To" name="grpTo" rules={[{ required: true, message: 'Please input your To Group!' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit"> Update </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

